// src/components/common/Pagination/Pagination.jsx
import React from 'react';
import styles from './Pagination.module.css';

const Pagination = ({
    currentPage,
    totalPages,
    totalItems,
    onPageChange,
    disabled = false,
    itemsLabel = 'itens',
}) => {
    if (totalPages <= 1) return null;

    const handlePrev = () => {
        if (disabled) return;
        if (currentPage > 1) {
            onPageChange(currentPage - 1);
        }
    };

    const handleNext = () => {
        if (disabled) return;
        if (currentPage < totalPages) {
            onPageChange(currentPage + 1);
        }
    };

    return (
        <div className={styles.paginationControls}>
            <button
                type="button"
                onClick={handlePrev}
                disabled={currentPage === 1 || disabled}
                className={styles.paginationButton}
            >
                ◀ Anterior
            </button>
            <span className={styles.paginationInfo}>
                Página <strong>{currentPage}</strong> de <strong>{totalPages}</strong>
                <span className={styles.totalItems}>
                    {' '}({totalItems} {itemsLabel})
                </span>
            </span>
            <button
                type="button"
                onClick={handleNext}
                disabled={currentPage === totalPages || disabled}
                className={styles.paginationButton}
            >
                Próxima ▶
            </button>
        </div>
    );
};

export default Pagination;